import React, { useState, useRef, useMemo } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import TokenInput from "react-customize-token-input";
import Swal from "sweetalert2";
import "react-customize-token-input/dist/react-customize-token-input.css";
import DommusRequiredSpan from "../../../../components/DommusRequiredSpan";
import caAPI from "../../../../services/caAPI";
import Anexos from "../../../../components/Anexos";
import { trackPromise } from "react-promise-tracker";
import EditorDommusTags from "../../../../components/EditorDommusTags";
import { Icon } from "@iconify/react";
import mailSendLine from "@iconify/icons-ri/mail-send-line";

export default function ModalEmail({
  assinatura,
  atendimento,
  AtualizarListaEmails,
  setOpenModalEmail,
  assunto
}) {
  const [assuntoInput, setAssuntoInput] = useState(defineAssuntoResposta(assunto));
  const [mensagemInput, setMensagemInput] = useState(assinatura);
  const [copiaCortesia, setCopiaCortesia] = useState([]);
  const [copiaCortesiaOculta, setCopiaCortesiaOculta] = useState([]);
  const [enviarComoComunicado, setEnviarComoComunicado] = useState(false);
  const [destinatarios, setDestinatarios] = useState([
    atendimento.contato_destino,
  ]);
  const [listaAnexos, setListaAnexos] = useState([]);
  const [filesTypes] = useState("*")
  const gruposTags = useMemo(() => [], []);

  const handleSubmitForm = function () {
    if (!assuntoInput || !mensagemInput) {
      Swal.fire({
        titleText: "Atenção",
        text: "Preencha todos os campos obrigatórios",
        icon: "info",
      });
      return;
    }
    const formData = new FormData();
    formData.append('id_atendimento', atendimento.id)
    formData.append('subject', assuntoInput)
    formData.append('conteudo', mensagemInput)
    formData.append('to', destinatarios)
    formData.append('cc', copiaCortesia)
    formData.append('bcc', copiaCortesiaOculta)
    formData.append('enviar_como_comunicado', enviarComoComunicado);
    if (listaAnexos && listaAnexos.length > 0) {
      listaAnexos.forEach(arquivo => {
        formData.append('attachments[]', arquivo)
      })
    }
    trackPromise(caAPI.atendimento.email.enviar(formData, true))
      .then((res) => {
        AtualizarListaEmails(atendimento.id);
        setOpenModalEmail(false);
      })
      .catch((e) => {
        Swal.fire({
          titleText: "Erro",
          text: "Houve um problema ao enviar o email",
          icon: "error",
        });
      });
  };

  function handleEditorChange(content, editor) {
    setMensagemInput(content);
  }

  function defineAssuntoResposta(assunto) {
    if(!assunto) {
      return ''
    }
    if(assunto.includes('RE: ')) {
      return assunto
    }
    return `RE: ${assunto}`
  }

  return (
    <div className="enviar-email-body">
      <Row className="body-email">
        <Col md={5} sm={12} className="form">
          <Form.Group controlId="formPara">
            <Form.Label>
              Para:
              <DommusRequiredSpan />
            </Form.Label>
            <Form.Control
              type="mail"
              defaultValue={atendimento.contato_destino}
              value={atendimento.contato_destino}
              onChange={(event) => setDestinatarios(event.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="formCC">
            <Form.Label>
              CC:{" "}
            </Form.Label>
            <TokenInput
              className="formCC"
              onTokensUpdate={(event) => {
                const novoCopiaCortesia = event.map((email) => email.value);
                setCopiaCortesia(novoCopiaCortesia);
              }}
            />
          </Form.Group>
          <Form.Group controlId="formCCO">
            <Form.Label>
              CCO:{" "}
            </Form.Label>
            <TokenInput
              className="formCCO"
              onTokensUpdate={(event) => {
                const novoCopiaCortesiaOculta = event.map((email) => email.value);
                setCopiaCortesiaOculta(novoCopiaCortesiaOculta);
              }}
            />
          </Form.Group>
          <Form.Group controlId="formAssunto">
            <Form.Label>
              Assunto:
              <DommusRequiredSpan />
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Digite o Assunto"
              value={assuntoInput}
              disabled={!!assunto}
              onChange={(event) => setAssuntoInput(event.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="form-como-comunicado">
            <Form.Check 
              type="checkbox" 
              checked={enviarComoComunicado}  
              label="Enviar e-mail como comunicado" 
              onChange={(event)=>{
                setEnviarComoComunicado(event.target.checked);
              }}        
            />
          </Form.Group>
          <Form.Group controlId="formMensagem">
            <Form.Label>Anexos:</Form.Label>
            <Anexos listaAnexos={listaAnexos} setListaAnexos={setListaAnexos} filesTypes={filesTypes} formData={true} />
          </Form.Group>
        </Col>
        <Col md={7} sm={12}>
          <Form.Group controlId="formMensagem">
            <Form.Label>
              Mensagem: <DommusRequiredSpan />
            </Form.Label>
            <div className="editor-email-section">
              <EditorDommusTags
                handleEditorChange={handleEditorChange}
                conteudo={mensagemInput || ''}
                gruposTags={gruposTags}
                utilizarDommusTag={false}
                assinatura={assinatura}
              />
            </div>
          </Form.Group>
        </Col>
      </Row>
      <div className="footer">
        <Button 
          type="button"
          variant="secondary"
          onClick={()=>{    
            setOpenModalEmail(false);
          }}            
        >
          Cancelar
        </Button>
        <Button
          type="submit"
          className="enviar"
          onClick={() => {
            handleSubmitForm();
          }}
        >
          <Icon icon={mailSendLine} fontSize={20} style={{ position: 'relative', top: '-1' }}/> Enviar Email
        </Button>
      </div>
    </div>
  );
}
